import { ticketDetailsLocales } from "app/containers/Features/containers/Ticket/locales";
import { formatEffortShorthand } from "app/containers/Features/helper";
import { TotalEffortType } from "app/types";
import React, { FC } from "react";

export const PopupHeader: FC<{
  totalEffortActual: TotalEffortType;
}> = ({ totalEffortActual }) => {
  return (
    <div className="flex items-center justify-between gap-3.5 py-5 px-4">
      <h6 className="text-sm font-medium text-black">
        {ticketDetailsLocales?.timeOnThisTask}
      </h6>

      <h6 className="text-sm font-medium text-black">
        {formatEffortShorthand(
          totalEffortActual?.hours,
          totalEffortActual?.minutes,
        )}
      </h6>
    </div>
  );
};
